"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Post = void 0;
var anchor = __importStar(require("@project-serum/anchor"));
var randombytes_1 = __importDefault(require("randombytes"));
var postmetadata_1 = require("./postmetadata");
var axios_1 = __importDefault(require("axios"));
var graphql_request_1 = require("graphql-request");
var Post = /** @class */ (function () {
    function Post(sdk) {
        this.sdk = sdk;
    }
    Post.prototype.get = function (postAccount) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.program.account.post.fetch(postAccount)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @deprecated This function is slow and may cause performance issues. Consider using getPostsByUser instead.
     */
    Post.prototype.getPostAccountsByUser = function (userPubKey) {
        return __awaiter(this, void 0, void 0, function () {
            var profiles, profilePDAs, posts, _i, profilePDAs_1, profilePDA, post;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.profile.getProfileAccountsByUser(userPubKey)];
                    case 1:
                        profiles = _a.sent();
                        profilePDAs = profiles.map(function (p) { return p.publicKey; });
                        posts = [];
                        _i = 0, profilePDAs_1 = profilePDAs;
                        _a.label = 2;
                    case 2:
                        if (!(_i < profilePDAs_1.length)) return [3 /*break*/, 5];
                        profilePDA = profilePDAs_1[_i];
                        return [4 /*yield*/, this.sdk.program.account.post.all([
                                { memcmp: { offset: 8, bytes: profilePDA.toBase58() } },
                            ])];
                    case 3:
                        post = _a.sent();
                        posts = __spreadArray(__spreadArray([], posts, true), post, true);
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, posts];
                }
            });
        });
    };
    Post.prototype.create = function (metadataUri, profileAccount, userAccount, owner) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, postMetadata, randomHash, instructionMethodBuilder, pubKeys, postPDA;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1["default"].get(metadataUri)];
                    case 1:
                        metadata = _a.sent();
                        postMetadata = new postmetadata_1.PostMetadata(metadata.data);
                        if (!postMetadata.validate()) {
                            throw new Error("Invalid post metadata");
                        }
                        randomHash = (0, randombytes_1["default"])(32);
                        instructionMethodBuilder = this.sdk.program.methods
                            .createPost(metadataUri, randomHash)
                            .accounts({
                            profile: profileAccount,
                            user: userAccount,
                            authority: owner
                        });
                        return [4 /*yield*/, instructionMethodBuilder.pubkeys()];
                    case 2:
                        pubKeys = _a.sent();
                        postPDA = pubKeys.post;
                        return [2 /*return*/, {
                                instructionMethodBuilder: instructionMethodBuilder,
                                postPDA: postPDA
                            }];
                }
            });
        });
    };
    Post.prototype.update = function (newMetadataUri, postAccount, profileAccount, userAccount, owner) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, postMetadata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1["default"].get(newMetadataUri)];
                    case 1:
                        metadata = _a.sent();
                        postMetadata = new postmetadata_1.PostMetadata(metadata.data);
                        if (!postMetadata.validate()) {
                            throw new Error("Invalid post metadata");
                        }
                        return [2 /*return*/, this.sdk.program.methods
                                .updatePost(newMetadataUri)
                                .accounts({
                                post: postAccount,
                                profile: profileAccount,
                                user: userAccount,
                                authority: owner
                            })];
                }
            });
        });
    };
    Post.prototype["delete"] = function (postAccount, profileAccount, userAccount, owner) {
        return this.sdk.program.methods
            .deletePost()
            .accounts({
            post: postAccount,
            profile: profileAccount,
            user: userAccount,
            authority: owner
        });
    };
    Post.prototype.reply = function (replyToPostAccount, metadataUri, profileAccount, userAccount, owner) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, postMetadata, randomHash, instructionMethodBuilder, pubKeys, postPDA;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1["default"].get(metadataUri)];
                    case 1:
                        metadata = _a.sent();
                        postMetadata = new postmetadata_1.PostMetadata(metadata.data);
                        if (!postMetadata.validate()) {
                            throw new Error("Invalid post metadata");
                        }
                        randomHash = (0, randombytes_1["default"])(32);
                        instructionMethodBuilder = this.sdk.program.methods
                            .createComment(metadataUri, randomHash)
                            .accounts({
                            profile: profileAccount,
                            user: userAccount,
                            authority: owner,
                            replyTo: replyToPostAccount
                        });
                        return [4 /*yield*/, instructionMethodBuilder.pubkeys()];
                    case 2:
                        pubKeys = _a.sent();
                        postPDA = pubKeys.post;
                        return [2 /*return*/, {
                                instructionMethodBuilder: instructionMethodBuilder,
                                postPDA: postPDA
                            }];
                }
            });
        });
    };
    // GraphQL Query methods
    Post.prototype.getAllPosts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query GetAllPosts {\n        gum_0_1_0_decoded_post {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"], ["\n      query GetAllPosts {\n        gum_0_1_0_decoded_post {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"])));
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.gum_0_1_0_decoded_post];
                }
            });
        });
    };
    Post.prototype.getPostsByUser = function (userPubKey) {
        return __awaiter(this, void 0, void 0, function () {
            var profiles, profilePDAs, query, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.profile.getProfilesByUser(userPubKey)];
                    case 1:
                        profiles = _a.sent();
                        profilePDAs = profiles.map(function (p) { return p.cl_pubkey; });
                        query = (0, graphql_request_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      query GetPostsByUser {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"], ["\n      query GetPostsByUser {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"])), profilePDAs.map(function (pda) { return "\"".concat(pda, "\""); }).join(","));
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data.gum_0_1_0_decoded_post];
                }
            });
        });
    };
    Post.prototype.getPostsByProfile = function (profilePubKey) {
        return __awaiter(this, void 0, void 0, function () {
            var query, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = (0, graphql_request_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      query GetPostsByProfile {\n        gum_0_1_0_decoded_post(where: {profile: {_eq: \"", "\"}}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"], ["\n      query GetPostsByProfile {\n        gum_0_1_0_decoded_post(where: {profile: {_eq: \"", "\"}}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"])), profilePubKey);
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.gum_0_1_0_decoded_post];
                }
            });
        });
    };
    Post.prototype.getPostsByNamespace = function (namespace) {
        return __awaiter(this, void 0, void 0, function () {
            var profiles, profilePDAs, query, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.profile.getProfilesByNamespace(namespace)];
                    case 1:
                        profiles = _a.sent();
                        profilePDAs = profiles.map(function (p) { return p.cl_pubkey; });
                        query = (0, graphql_request_1.gql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      query GetPostsByNamespace {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"], ["\n      query GetPostsByNamespace {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"])), profilePDAs.map(function (pda) { return "\"".concat(pda, "\""); }).join(","));
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data.gum_0_1_0_decoded_post];
                }
            });
        });
    };
    Post.prototype.getPostsByFollowedUsers = function (profileAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var followedUsersProfileAccounts, query, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.connection.getFollowingsByProfile(profileAccount)];
                    case 1:
                        followedUsersProfileAccounts = _a.sent();
                        query = (0, graphql_request_1.gql)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      query GetPostsByFollowedUsers {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"], ["\n      query GetPostsByFollowedUsers {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }"])), followedUsersProfileAccounts.map(function (pda) { return "\"".concat(pda, "\""); }).join(","));
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data.gum_0_1_0_decoded_post];
                }
            });
        });
    };
    Post.prototype.getFeedsByFollowedUsers = function (profileAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var followedUsersProfileAccounts, query, data, feed;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdk.connection.getFollowingsByProfile(profileAccount)];
                    case 1:
                        followedUsersProfileAccounts = _a.sent();
                        query = (0, graphql_request_1.gql)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      query GetFeedsByFollowedUsers {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }\n    "], ["\n      query GetFeedsByFollowedUsers {\n        gum_0_1_0_decoded_post(where: {profile: {_in: [", "] }}) {\n          cl_pubkey\n          metadata\n          metadatauri\n          profile\n        }\n      }\n    "])), followedUsersProfileAccounts.map(function (pda) { return "\"".concat(pda, "\""); }).join(","));
                        return [4 /*yield*/, this.sdk.gqlClient.request(query)];
                    case 2:
                        data = _a.sent();
                        return [4 /*yield*/, Promise.all(data.gum_0_1_0_decoded_post.map(function (post) { return __awaiter(_this, void 0, void 0, function () {
                                var profileData;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.sdk.profileMetadata.getProfileMetadataByProfile(new anchor.web3.PublicKey(post.profile))];
                                        case 1:
                                            profileData = _a.sent();
                                            return [2 /*return*/, {
                                                    cl_pubkey: post.cl_pubkey,
                                                    metadata: post.metadata,
                                                    metadatauri: post.metadatauri,
                                                    profile: profileData.profile,
                                                    profile_metadata: profileData.metadata,
                                                    profile_metadata_uri: profileData.metadatauri
                                                }];
                                    }
                                });
                            }); }))];
                    case 3:
                        feed = _a.sent();
                        return [2 /*return*/, feed];
                }
            });
        });
    };
    return Post;
}());
exports.Post = Post;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
